/** Kontakt — direktno na formu (kanonska URL putanja). */
export const CONTACT_FORM_PATH = '/kontakt#kontakt-forma';
